import {createSlice} from "@reduxjs/toolkit";
import ReduxStoreRoutes from "../../../../core/models/static/routes/redux-store-routes";

export const reduxStoreVendorProfileInitialState = {
    data: null,
}


/**
 * The vendor profile slice that exists in the redux store.
 * This reducer is used to contain and apply live updates to the selected vendor's information.
 */
const reduxStoreVendorProfileSlice = createSlice({
    name: ReduxStoreRoutes.vendorProfile,
    initialState: reduxStoreVendorProfileInitialState,
    reducers: {
        /**
         * Sets the vendor information in the vendor profile section of redux
         * @param state
         * @param action
         */
        set: (state, action) => {
            const newRes = {...state.data};
            Object.entries(action.payload ?? {}).forEach(([key, value]) => {
                if (newRes[key]) {
                    switch (typeof newRes[key]) {
                        case 'object':
                            newRes[key] = {...newRes[key], ...value};
                            break;
                        default:
                            newRes[key] = value;
                    }
                    return;
                }
                newRes[key] = value;
            })
            state.data = newRes;
            return state;
        },
        /**
         * Removes the vendor's information from the user profile section of redux
         * @param state
         * @param action
         * @return {Draft<State>}
         */
        remove: (state, action) => {
            state.data = null;
            return state;
        },
    }
});


export default reduxStoreVendorProfileSlice;

